

document.addEventListener("DOMContentLoaded", function() {
  // Verificamos si existe la sección con clase 'seo-enova-collection'
  const seoSection = document.querySelector('.seo-enova-collection');
  if (!seoSection) return;

  // Buscamos los h2 dentro de esa sección
  const headings = seoSection.querySelectorAll('h2');

  headings.forEach(h2 => {
    // Tomamos el siguiente elemento hermano
    const next = h2.nextElementSibling;

    // Verificamos si el siguiente elemento es un <p>
    if (next && next.tagName.toLowerCase() === 'p') {
      // Creamos un nuevo section
      const newSection = document.createElement('section');
      newSection.classList.add('seo-enova-block'); // clase para estilos si quieres

      // Movemos el h2 y el p dentro del nuevo section
      h2.parentNode.insertBefore(newSection, h2);
      newSection.appendChild(h2);
      newSection.appendChild(next);
    }
  });
});